const config = {
  local: {},
  staging: {},
  production: {},
};

export const CHECKOUT_CONFIG = config[process.env.VUE_APP_ENV];